import propTypes from 'prop-types'
import { memo } from 'react'
import Image from '../assets/banner.webp'
import WhatsAppButton from './WhatsAppButton'
import classNames from 'classnames'

const Banner = ({
  title,
  description,
  message,
  titleFullWidth = false,
  whatsappIconLeft = false,
  contact
}) => {
  return (
    <div className='Banner'>
      <img
        className="Banner__Image"
        src={Image}
        alt="Vida Cowork"
        title="Vida Cowork"
      />
      <div className={classNames('Banner__Title-Container container-custom', {
        'title-full-width': titleFullWidth
      })}>
        <div className="d-flex flex-column gap-2">
          <h1 className="title">
            { title }
          </h1>
          <p className='text-1'>
            { description }
          </p>
        </div>
        <WhatsAppButton
          label="Reservar ahora"
          message={message}
          withIconLeft={whatsappIconLeft}
          contact={contact}
        />
      </div>
    </div>
  )
}

Banner.propTypes = {
  title: propTypes.string,
  description: propTypes.string,
  message: propTypes.string,
  titleFullWidth: propTypes.bool,
  whatsappIconLeft: propTypes.bool,
  contact: propTypes.string
}

export default memo(Banner)
